import React from 'react';
import { TableRow, TableHeader } from '@insurancemenu/imenu-components-lib';
import { TableHeadingStyled } from './styles';

const headings = [
  { title: 'Agency Name', width: '8rem' },
  { title: 'Group Name', width: '8rem' },
  { title: 'Effective Dates', width: '6rem' },
  { title: 'Product Lines', width: '7rem' },
  { title: 'Stage', width: '5rem' },
  { title: 'Emails', width: '6rem' },
  { title: '', width: '6rem' },
];

const TriggerRenewalsHeader: React.FC = () => {
  return (
    <TableHeader>
      <TableRow>
        {headings.map((headingObj) => (
          <TableHeadingStyled {...headingObj} key={headingObj.title}>
            {headingObj.title}
          </TableHeadingStyled>
        ))}
      </TableRow>
    </TableHeader>
  );
};

export default TriggerRenewalsHeader;
